
<ng-template #preCartReviewModal let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <div class="modal-bg pre-cart-review">
                        <button type="button" id="close-pre-cart-modal" class="close" (click)="modal.dismiss('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        
                        
                        <div class="modal-header-section text-center mb-4">
                            <h3 class="modal-title">Before you checkout, here are some suggestions!</h3>
                            <p class="modal-subtitle">Complete your order with these recommended items</p>
                        </div>

                        
                        <div class="row pre-cart-sections">
                            <div class="col-md-6 col-12 d-flex flex-column">
                                
                                <div class="section-container flex-fill" *ngIf="mproducts.length > 0">
                                    <div class="section-header mb-3">
                                        <h4 class="section-title">
                                            <i class="fa fa-history me-2"></i>
                                            Catch what you missed from your last order
                                        </h4>
                                        <p class="section-description">Items you purchased before but haven't added this time</p>
                                    </div>
                                    
                                    <div class="collection-product-wrapper" id="last-order-products">
                                        <div class="product-wrapper-grid p-2 me-4" [ngClass]="layoutView">
                                            <div class="row">
                                                <div
                                                    class="col-grid-box col-12 col-sm-6"
                                                    [ngClass]="'col-md-12 col-lg-6'"
                                                    *ngFor="let product of mproducts"
                                                >
                                                    <div class="product-box">
                                                        <app-product-box-one
                                                            [product]="product"
                                                            [currency]="productService?.Currency"
                                                            [thumbnail]="false"
                                                            [cartModal]="false"
                                                            [loader]="true"
                                                        >
                                                        </app-product-box-one>
                                                    </div>
                                                </div>
                                                
                                                
                                                <div class="col-sm-12 text-center section-b-space mt-3" *ngIf="mproducts.length === 0">
                                                    <p class="text-muted">No items from your last order are missing in your current cart.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 d-flex flex-column">
                                
                                <div class="section-container flex-fill" *ngIf="missinpromoproducts.length > 0">
                                    <div class="section-header mb-3 mt-4 mt-md-0">
                                        <h4 class="section-title">
                                            <i class="fa fa-gift me-2"></i>
                                            You are missing these promo products
                                        </h4>
                                        <p class="section-description">Add these items to complete your promotional offers</p>
                                    </div>
                                    
                                    <div class="collection-product-wrapper" id="promo-products">
                                        <div class="product-wrapper-grid p-2" [ngClass]="layoutView">
                                            <div class="row">
                                                <div
                                                    class="col-grid-box col-12 col-sm-6"
                                                    [ngClass]="'col-md-12 col-lg-6'"
                                                    *ngFor="let product of missinpromoproducts"
                                                >
                                                    <div class="product-box">
                                                        <app-product-box-one
                                                            [product]="product"
                                                            [currency]="productService?.Currency"
                                                            [thumbnail]="false"
                                                            [cartModal]="false"
                                                            [loader]="true"
                                                        >
                                                        </app-product-box-one>
                                                    </div>
                                                </div>
                                                
                                                
                                                <div class="col-sm-12 text-center section-b-space mt-3" *ngIf="missinpromoproducts.length === 0">
                                                    <p class="text-muted">All promotional requirements are already in your cart.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                        <div class="empty-suggestions text-center py-4" *ngIf="mproducts.length === 0 && missinpromoproducts.length === 0">
                            <i class="fa fa-check-circle text-success" style="font-size: 3rem;"></i>
                            <h4 class="mt-3">You're all set!</h4>
                            <p class="text-muted">No additional items to suggest. Your cart looks great!</p>
                        </div>

                        
                        <div class="modal-actions text-center mt-4 pt-3 border-top">
                            <div class="d-flex justify-content-center gap-3">
                                <button 
                                    class="btn btn-outline-secondary btn-lg"
                                    (click)="modal.dismiss('continue')"
                                >
                                    <i class="fa fa-arrow-left me-2"></i>
                                    Continue Shopping
                                </button>
                                
                                <button 
                                    class="btn btn-solid btn-lg"
                                    (click)="continueToCart()"
                                >
                                    <i class="fa fa-shopping-cart me-2"></i>
                                    Proceed to Cart
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

